import { getMessages } from 'app/store/constants';

export const VIEW_ONLY_TITLE = getMessages().getText('common.view_only');
export const COMMENT_ONLY_TITLE = getMessages().getText('common.comment_only');
export const MIN_WIDTH_DISPLAY_VIEW_TITLE = 420;
export const MIN_WIDTH_DISPLAY_COMMENT_TITLE = 450;
